import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as s } from "react";
const i = ({
  title: l,
  titleId: o,
  ...c
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...c,
    children: [
      l ? /* @__PURE__ */ e.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M705.355 544.335H323.062c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667h382.293c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667m-289.5 187.791H291.396c-125.397 0-227.392-102.016-227.392-227.413 0-125.376 101.995-227.371 227.392-227.371h123.627c23.552 0 42.667 19.093 42.667 42.667 0 23.552-19.115 42.667-42.667 42.667H291.396c-78.336 0-142.059 63.723-142.059 142.037 0 78.357 63.723 142.08 142.059 142.08h124.459c23.552 0 42.667 19.115 42.667 42.667s-19.115 42.667-42.667 42.667zm321.186 0H612.582c-23.552 0-42.667-19.115-42.667-42.667s19.115-42.667 42.667-42.667h124.459c78.336 0 142.059-63.723 142.059-142.08 0-78.315-63.723-142.037-142.059-142.037H613.414c-23.552 0-42.667-19.115-42.667-42.667 0-23.573 19.115-42.667 42.667-42.667h123.627c125.397 0 227.392 101.995 227.392 227.371 0 125.397-101.995 227.413-227.392 227.413z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), n = s(i);
export {
  n as default
};
